import { render, staticRenderFns } from "./LandingFormType.vue?vue&type=template&id=550609ac&scoped=true&lang=pug&"
import script from "./LandingFormType.vue?vue&type=script&lang=js&"
export * from "./LandingFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550609ac",
  null
  
)

/* custom blocks */
import block0 from "./LandingFormType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
